// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: std_msgs/msg/Header.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Time } from "../../builtin_interfaces/msg/Time";

export const protobufPackage = "std_msgs.msg.pb";

/**
 * Standard metadata for higher-level stamped data types.
 * This is generally used to communicate timestamped data
 * in a particular coordinate frame.
 */
export interface Header {
  /** Two-integer timestamp that is expressed as seconds and nanoseconds. */
  stamp:
    | Time
    | undefined;
  /** Transform frame with which this data is associated. */
  frame_id: string;
}

function createBaseHeader(): Header {
  return { stamp: undefined, frame_id: "" };
}

export const Header: MessageFns<Header> = {
  encode(message: Header, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.stamp !== undefined) {
      Time.encode(message.stamp, writer.uint32(2859816474).fork()).join();
    }
    if (message.frame_id !== "") {
      writer.uint32(4246624458).string(message.frame_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Header {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 357477059: {
          if (tag !== 2859816474) {
            break;
          }

          message.stamp = Time.decode(reader, reader.uint32());
          continue;
        }
        case 530828057: {
          if (tag !== 4246624458) {
            break;
          }

          message.frame_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Header {
    return {
      stamp: isSet(object.stamp) ? Time.fromJSON(object.stamp) : undefined,
      frame_id: isSet(object.frameId)
        ? globalThis.String(object.frameId)
        : isSet(object.frame_id)
        ? globalThis.String(object.frame_id)
        : "",
    };
  },

  toJSON(message: Header): unknown {
    const obj: any = {};
    if (message.stamp !== undefined) {
      obj.stamp = Time.toJSON(message.stamp);
    }
    if (message.frame_id !== "") {
      obj.frameId = message.frame_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Header>, I>>(base?: I): Header {
    return Header.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Header>, I>>(object: I): Header {
    const message = createBaseHeader();
    message.stamp = (object.stamp !== undefined && object.stamp !== null) ? Time.fromPartial(object.stamp) : undefined;
    message.frame_id = object.frame_id ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
